module.exports = __webpack_public_path__ + "img/gu.2284e60e.svg";